export class ConstructScene {
  constructor (Scene, sceneColor, sceneFog) {
    this.scene = new Scene()
    this.scene.name = 'main scene'
    this.scene.background = sceneColor
    this.scene.fog = sceneFog

    this.camera = null
    this.renderer = null
    this.controls = null
  }

  constructCamera (PerspectiveCamera, CanvasHeight) {
    this.camera = new PerspectiveCamera(45, (window.innerWidth) / (window.innerHeight - CanvasHeight), 10, 15000)
    this.camera.position.set(0, 0, 0)

    return this
  }

  constructControls (OrbitControls, domElement) {
    this.controls = new OrbitControls(this.camera, domElement)
    this.controls.target.set(0, 0, 0)
    this.controls.maxDistance = 6000
    this.controls.minDistance = 500
    this.controls.autoRotate = false
    this.controls.autoRotateSpeed = 0.05
    this.controls.enableDamping = true
    this.controls.dampingFactor = 0.4
    this.controls.maxPolarAngle = (Math.PI / 2) - 0.15
    this.controls.update()

    return this
  }

  constructRenderer (WebGlRenderer, CanvasHeight, PCFSoftShadowMap) {
    this.renderer = new WebGlRenderer({
      antialias: true,
      powerPreference: 'high-performance'
    })
    this.renderer.setPixelRatio(window.devicePixelRatio)
    this.renderer.setSize((window.innerWidth), (window.innerHeight - CanvasHeight))
    this.renderer.shadowMap.enabled = true
    // this.renderer.gammaInput = true;
    // this.renderer.gammaOutput = true;
    // this.renderer.physicallyCorrectLights = true;
    // this.renderer.outputEncoding = THREE.sRGBEncoding;
    this.renderer.shadowMap.type = PCFSoftShadowMap
    return this
  }
}

export class Lights {
  constructor (AmbientLight, DirectionalLight, cameraHelper) {
    this.cameraHelper = cameraHelper;
    this.ambient = new AmbientLight(0xe8ecff, 1.4)
    this.ambient.name = 'ambientLight'
    this.directionalLight = new DirectionalLight(0xfff1f1, 0.7)
    // this.shadowCameraHelper = new cameraHelper(this.directionalLight.shadow.camera)
    // this.directionalLightHelper = new directionalLight(0x87c0ff, 0.2)
  }

  createDirectionalLight () {
    this.directionalLight.name = 'directionalLight'
    this.directionalLight.position.set(900, 900, -500)
    this.directionalLight.castShadow = true

    this.directionalLight.shadow.camera.right = 2500
    this.directionalLight.shadow.camera.left = -2500
    this.directionalLight.shadow.camera.top = 2500
    this.directionalLight.shadow.camera.bottom = -2500
    this.directionalLight.shadow.camera.near = 0
    this.directionalLight.shadow.camera.far = 5000

    // this.shadowCameraHelper.visible = false
    // this.shadowCameraHelper.name = 'shadowCameraHelper'
  }

  // createDirectionalLightHelper(directionalLight){
  //   this.directionalLightHelper.name = 'directionalLightHelper'
  //   this.directionalLightHelper.position.set(1, 1, -1)
  // }
}

/**
 * import THREEjs library
 */
const THREE = require('three');
const loader = new THREE.ObjectLoader();

import {
  colorList
} from '@/assets/js/library.js'

// export function loadModel (dispatchObject, ID) {

//   let parseModel = JSON.parse(dispatchObject);

//   const loadedModel = loader.parse(parseModel, (model)=>{
//     model.name = ID;

//     return model;
//   },
//   ((xhr)=>{
//     console.debug((xhr.loaded / xhr.total) * 100);
//   }),
//   ((err)=>{
//     console.warn(err);
//   }));

//   return loadedModel;
// }

export function parseModel (dispatchObject, ID) {

  const loadedModel = loader.parse(dispatchObject, (model)=>{
    model.name = ID;

    return model;
  },
  ((xhr)=>{
    console.debug((xhr.loaded / xhr.total) * 100);
  }),
  ((err)=>{
    console.warn(err);
  }));

  return loadedModel;
}


export function colorMesh (obj, colorRamp) {

  const mats = {
    'MeshStandardMaterial': THREE.MeshStandardMaterial
  }

  const checkColorMaterialList = (color, materialType) => {
    const colorKeys = Object.keys(colorList[materialType]['colors'])
    // check to see if color exisits in dictionary
    if (colorKeys.includes(color) === false) {
      colorList[materialType]['colors'][color] = new mats[materialType](colorList[materialType]['options'])

      colorList[materialType]['colors'][color].color = new THREE.Color(color)
    }
    return colorList[materialType]['colors'][color]
  }

  obj.traverse(function (child) {
    if (child instanceof THREE.Mesh) {
      if (child.userData) {

        const value = parseFloat(child.userData['customAttribute'])

        const color = colorRamp(value).hex()

        child.material = checkColorMaterialList(color, 'MeshStandardMaterial');

        child.receiveShadow = false

        if (child.name === 'buildings') {
          child.castShadow = true
        } else {
          child.castShadow = false
        }
      }
    }
  });
  return Object.assign(obj, {_isVue: true })
}

export function createCopies (modelCopyData,sceneName, scale, loadedModels){
  let localScene = new THREE.Scene();
  localScene.name = sceneName;

  modelCopyData.forEach((modelObject)=>{

    const { x, y ,z ,type } = modelObject

    if(
      type !== undefined &&
      x !== undefined &&
      y !== undefined &&
      z !== undefined &&
      type.length > 1
    ){

      let geo = new THREE.Object3D();

      const key = type.trim() + ".json";
      geo.copy(loadedModels[key]);
      
      geo.position.set(-parseFloat(x), parseFloat(z), parseFloat(y));
      geo.rotation.y = (Math.PI / 2) * (Math.random() * (Math.PI * 2));
  
      geo.scale.set(scale,scale,scale);
  
      localScene.add(geo);
    }
  });

  return localScene;
}